import { createGlobalStyle } from "styled-components";

export const CookieConsentStyles = createGlobalStyle`
  #cc-main {
    /* CSS Variables */
    --cc-font-family: ${({ theme }) => theme.typography.RegularParagraph.fontFamily};
    --cc-modal-border-radius: ${({ theme }) => theme.borderRadius.S};
    --cc-btn-border-radius: ${({ theme }) => theme.borderRadius.L};
    --cc-modal-margin: ${({ theme }) => theme.spacers.M};

    /* Colors */
    --cc-bg: ${({ theme }) => theme.colors.background.white};
    --cc-primary-color: ${({ theme }) => theme.colors.text.darkerGrey};
    --cc-secondary-color: ${({ theme }) => theme.colors.text.darkGrey};
    
    /* Buttons */
    --cc-btn-primary-bg: ${({ theme }) => theme.colors.text.darkerGrey};
    --cc-btn-primary-color: ${({ theme }) => theme.colors.text.white};
    --cc-btn-secondary-bg: transparent;
    --cc-btn-secondary-color: ${({ theme }) => theme.colors.text.darkerGrey};
    --cc-btn-secondary-border-color: ${({ theme }) => theme.colors.text.darkerGrey};
    
    /* Toggle */
    --cc-toggle-off-bg: ${({ theme }) => theme.colors.text.lightGrey};
    --cc-toggle-on-bg: ${({ theme }) => theme.colors.text.darkerGrey};
    --cc-toggle-on-knob-bg: ${({ theme }) => theme.colors.text.white};
    --cc-toggle-off-knob-bg: ${({ theme }) => theme.colors.text.white};
    
    /* Sections */
    --cc-cookie-category-block-bg: ${({ theme }) => theme.colors.background.superLightGrey};
    --cc-cookie-category-block-border: transparent;
    --cc-separator-border-color: ${({ theme }) => theme.colors.stroke.lighterGrey};

    /* Base Modal */
    .cm {
      box-shadow: ${({ theme }) => theme.shadows.normal};

      &__body {
        padding: ${({ theme }) => theme.spacers.XL};
      }

      &__desc {
        max-height: 25vh;
        overflow-y: auto;
        mask-image: linear-gradient(to bottom, black 85%, transparent 100%);
        -webkit-mask-image: linear-gradient(to bottom, black 85%, transparent 100%);
        scrollbar-width: none;
        font-size: ${({ theme }) => theme.typography.SmallParagraph.fontSize};
        line-height: ${({ theme }) => theme.typography.SmallParagraph.lineHeight};
        margin-bottom: ${({ theme }) => theme.spacers.XL};
        color: var(--cc-secondary-color);

        &::-webkit-scrollbar {
          display: none;
        }

        &:first-child {
          margin-top: 0;
        }
      }

      &__title {
        font-size: ${({ theme }) => theme.typography.TinyHeadline.fontSize};
        font-weight: ${({ theme }) => theme.typography.TinyHeadline.fontWeight};
        margin-bottom: ${({ theme }) => theme.spacers.M};
      }

      &__btns {
        border-top: none;

        /* Settings Ghost Button */
        div:nth-child(2) button {
          border: none;
          text-decoration: underline;
        }
      }

      /* Button Border */
      &__btn {
        border: 2px solid var(--cc-btn-primary-border-color);
      }

      &__btn--secondary:hover {
        background-color: var(--cc-btn-secondary-bg);
      }
    }

    /* Reset Paddings */
    .cm__desc,
    .cm__title,
    .cm__btn,
    .pm__section--toggle .pm__section-desc {
      padding: 0;
    }

    @media (${({ theme }) => theme.screens.tablet}) {
      .cm__texts,
      .cm__btns {
        padding: 0;
      }
    }

    /* Preferences Modal */
    .pm {
      &__btn {
        background-color: var(--cc-btn-primary-bg);
        color: var(--cc-btn-primary-color);
        border: none;

        &:hover {
          background-color: ${({ theme }) => theme.colors.hover.superDarkGrey};
          color: var(--cc-btn-primary-color);
        }
      }

      &--bar:not(.pm--wide) .pm__body {
        padding-top: 0;
        padding-bottom: 0;
      }

      &__section {
        &:first-child {
          margin-bottom: 0;
        }

        &--expandable .pm__section-title {
          padding-left: 0;
        }

        &--expandable .pm__section-arrow {
          display: none;
        }

        &--toggle {
          background: transparent;
          border: none;

          .pm__section-desc-wrapper {
            display: flex;
            border: none;
            border-radius: 0;
          }

          .pm__section-title,
          .pm__section-title:hover {
            background: transparent;
            border: none;
          }
        }
      }

      &__header,
      &__footer {
        border: none;
      }

      &__close-btn {
        border-radius: 50%;
        background-color: ${({ theme }) => theme.colors.background.superLightGrey};
        border: none;
      }
    }

    /* Hide Toggle Icons */
    .toggle__icon-off,
    .toggle__icon-on {
      display: none;
    }

    @media screen and (max-width: 640px) {
      .cm__btns {
        border-top: 0 !important;
      }
    }
  }
`;
